import React, { useEffect, useState } from 'react';
import { Card } from 'reactstrap';
import { Icon } from '../../../../components/Component';

const TenantStoreStatistics = ({ sales }) => {

 const [sales_data, setSalesData] = useState(sales);

 useEffect(() => {
  setSalesData(sales);
 }, [sales]);

 return (
  <>
   <Card className="h-100">
    <div className="card-inner">
     <div className="card-title-group mb-2">
      <div className="card-title">
       <h6 className="title">Store Statistics</h6>
      </div>
     </div>
     <ul className="nk-store-statistics">
      <li className="item">
       <div className="info">
        <div className="title">Orders</div>
        <div className="count">{sales_data?.total_orders || 0}</div>
       </div>
       <Icon name="bag" className="bg-primary-dim"></Icon>
      </li>
      <li className="item">
       <div className="info">
        <div className="title">Sales Representatives</div>
        <div className="count">{sales_data?.total_sales_reps || 0}</div>
       </div>
       <Icon name="users" className="bg-info-dim"></Icon>
      </li>
      <li className="item">
       <div className="info">
        <div className="title">Products</div>
        <div className="count">{sales_data?.total_products || 0}</div>
       </div>
       <Icon name="box" className="bg-pink-dim"></Icon>
      </li>
      <li className="item">
       <div className="info">
        <div className="title">Categories</div>
        <div className="count">{sales_data?.categories || 0}</div>
       </div>
       <Icon name="server" className="bg-purple-dim"></Icon>
      </li>
     </ul>
    </div>
   </Card>
  </>
 );
};

export default TenantStoreStatistics;